import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for card values
export const Cardvalues = createSlice({
  name: "Cardvalues",
  initialState: {
    api_completed: false,
    isLoading: false,
    isSuccess: false,
    switch: false,
    data: {},
  },
  reducers: {
    Cardvalues_datagrid: (state, a) => {
      state.data = a.payload;
      state.switch = true
    },
    success_api_call_Cardvalues_datagrid: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
    },
    failure_api_call_Cardvalues_datagrid: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.api_completed = true;
    },
    Cardvalues_datagrid_is_success: (state, action) => {
      state.isSuccess = false;
    },
    create_Cardvalues_datagrid_complete_api: (state, action) => {
      state.api_completed = false;
    },
    false_switchCardvalues:(state)=>{
        state.switch = false
    }
  },
});
export default Cardvalues.reducer;
export const {
  Cardvalues_datagrid,
  success_api_call_Cardvalues_datagrid,
  failure_api_call_Cardvalues_datagrid,
  create_Cardvalues_datagrid_complete_api,
  Cardvalues_datagrid_is_success,false_switchCardvalues
} = Cardvalues.actions;
